import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';
import {
  BlueberryFeatures,
  FeatureEnum,
} from '../../../services/data/impl/cube/cubeSlice';
import { selectCurrBlueberryClass } from '../../select/selectSlice';
import { useBlueberryFlowerFeatures } from './useBlueberryFlowerFeatures';

export const useBlueberryQueryValues = () => {
  const currBlueberryClass = useAppSelector(selectCurrBlueberryClass);
  const flowerFeatures = useBlueberryFlowerFeatures();

  const blueberryQueryValues = useMemo(() => {
    let queryValues: FeatureEnum[];

    if (currBlueberryClass === null) {
      queryValues = [...BlueberryFeatures, ...flowerFeatures];
    } else if (currBlueberryClass === FeatureEnum.blueberry) {
      queryValues = BlueberryFeatures;
    } else if (currBlueberryClass === FeatureEnum.flower) {
      queryValues = flowerFeatures;
    } else {
      queryValues = [currBlueberryClass];
    }

    return queryValues;
  }, [currBlueberryClass, flowerFeatures]);

  return blueberryQueryValues;
};
